<div
  class="flex items-center gap-4 rounded-lg border border-gray-200 p-4"
  [class.bg-gray-50]="isDraft"
  [class.bg-white]="!isDraft"
>
  <!-- Trip Image or Placeholder Icon -->
  <div class="h-16 w-24 flex-shrink-0 overflow-hidden rounded-md bg-gray-100">
    @if (hasValidImage() && trip.imagePath) {
      <img
        [src]="getImageUrl(trip.imagePath)"
        [alt]="trip.title"
        class="h-full w-full object-cover"
        (error)="onImageError()"
      />
    } @else {
      <div
        class="flex h-full w-full items-center justify-center bg-primary-100"
      >
        <lucide-icon
          [img]="mapIcon"
          class="h-6 w-6 text-primary-600"
        ></lucide-icon>
      </div>
    }
  </div>

  <!-- Trip Info -->
  <div class="min-w-0 flex-1">
    <div class="flex items-center gap-2">
      <h4 class="truncate text-base font-medium text-gray-900">
        {{ trip.title }}
      </h4>
      @if (isContributed) {
        <span
          class="rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700"
        >
          {{ "contributions.selectTripModal.compensatedBadge" | transloco }}
        </span>
      }
      @if (isDraft) {
        <span
          class="rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-600"
        >
          {{ "contributions.selectTripModal.draftBadge" | transloco }}
        </span>
      }
    </div>

    <div class="mt-1 flex items-center gap-2 text-sm text-gray-500">
      @if (trip.countryName) {
        <span>{{ trip.countryName }}</span>
        <span class="text-gray-300">·</span>
      }
      <span>{{ trip.days }} {{ trip.days > 1 ? "jours" : "jour" }}</span>
      <span class="text-gray-300">·</span>
      <span
        >{{ trip.travellers }}
        {{ trip.travellers > 1 ? "voyageurs" : "voyageur" }}</span
      >
    </div>

    <div class="mt-1 text-sm">
      @if (trip.hasImpact && !isDraft) {
        <span class="font-medium text-primary-600">
          {{ formatCO2(trip.totalImpact) }}
        </span>
        @if (isContributed && trip.lastContributionDate) {
          <span class="ml-2 text-gray-400">
            · {{ "contributions.selectTripModal.contributedOn" | transloco }}
            {{ trip.lastContributionDate | date: "dd MMM yyyy" }}
          </span>
        }
      } @else {
        <span class="italic text-gray-400">
          {{ "contributions.selectTripModal.impactNotCalculated" | transloco }}
        </span>
      }
    </div>
  </div>

  <!-- Action Button -->
  <div class="flex-shrink-0">
    @if (isDraft) {
      <p-button
        [label]="'contributions.selectTripModal.finalize' | transloco"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="finalizeTrip.emit(trip)"
      />
    } @else if (isContributed) {
      <p-button
        [label]="'contributions.selectTripModal.contributeAgain' | transloco"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="selectTrip.emit(trip)"
      />
    } @else {
      <p-button
        [label]="'contributions.selectTripModal.selectButton' | transloco"
        size="small"
        (onClick)="selectTrip.emit(trip)"
      />
    }
  </div>
</div>
